import React from 'react'

import { EyebrowType } from '@/fields/eyebrow'
import { StatsCard } from '@/components/StatsCard'

export function GrantStats(props: {
  eyebrow: EyebrowType
  projectCount: number
  usdDeployed: number
  className?: string
  size?: 'lg' | 'md'
}) {
  const { projectCount, usdDeployed, eyebrow, className, size = 'md' } = props

  return (
    <StatsCard
      className={className}
      size={size}
      eyebrow={eyebrow}
      stats={[
        { label: 'Projects built on Sia', value: projectCount.toString() },
        {
          label: `allocated to grant funding in ${new Date().getFullYear()}`,
          value: `$${(usdDeployed / 1_000_000).toFixed(1)}M`,
        },
      ]}
    />
  )
}
